var React = require('react');

function CircleCheck (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16.5","cy":"16.5","r":"15","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M9.5 17.6106L13.8093 21.0372L22.6061 12.5","strokeWidth":"3","strokeLinejoin":"round","key":1})]);
}

CircleCheck.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 33 33","stroke":"black","fill":"none"};

module.exports = CircleCheck;

CircleCheck.default = CircleCheck;
